import React from 'react'
import { IncentiveRadio } from '../baseComponents/IncentiveRadio/IncentiveRadio';

export const IncentiveCalculationType = (props: { stateName: string }) => {
    const options = [
        { 
            value: "SALES",
            description: "The incentive points will be calculated once the order is converted into sales.Negative sales , rejected orders, unfulfilled orders will not be considered."
          },
          {
            value: "ORDER",
            description: "The incentive points will be calculated when the order is synced , Order rejected from app will not be considered."
          }
        ]
    return (
        <IncentiveRadio stateName={props.stateName} options={options}/>
    )
}
